import { NavLink } from 'react-router-dom';

import type { SiteContent } from '../../content/types';
import { Container } from './container';

interface SiteFooterProps {
  content: SiteContent;
}

function isInternalLink(href: string): boolean {
  return href.startsWith('/');
}

export function SiteFooter({ content }: SiteFooterProps): JSX.Element {
  return (
    <footer className="border-t border-[color:var(--color-border)] bg-[color:var(--color-surface-alt)]/60">
      <Container className="grid gap-8 py-12 lg:grid-cols-[1.2fr_2fr]">
        <div className="space-y-3">
          <div className="inline-flex items-center gap-3">
            {content.brand.hasLogoAsset ? (
              <img src={content.brand.logoPath} alt={content.brand.name} className="h-12 w-auto rounded-lg" />
            ) : (
              <span className="text-xl font-semibold text-[color:var(--color-text)]">{content.brand.shortName}</span>
            )}
          </div>
          <p className="text-sm text-[color:var(--color-muted)]">{content.brand.tagline}</p>
          <p className="text-sm font-medium text-[color:var(--color-text)]">{content.footer.claim}</p>
        </div>

        <div className="grid gap-6 sm:grid-cols-3">
          {content.footer.columns.map((column) => (
            <div key={column.title} className="space-y-3">
              <h2 className="text-sm font-semibold uppercase tracking-wide text-[color:var(--color-muted)]">{column.title}</h2>
              <ul className="space-y-2">
                {column.links.map((link) => (
                  <li key={link.href + link.label}>
                    {isInternalLink(link.href) ? (
                      <NavLink className="text-sm text-[color:var(--color-text)] hover:text-[color:var(--color-primary)]" to={link.href}>
                        {link.label}
                      </NavLink>
                    ) : (
                      <a className="text-sm text-[color:var(--color-text)] hover:text-[color:var(--color-primary)]" href={link.href} target={link.href.startsWith('http') ? '_blank' : undefined} rel={link.href.startsWith('http') ? 'noreferrer' : undefined}>
                        {link.label}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </Container>
      <Container className="border-t border-[color:var(--color-border)] py-5">
        <p className="text-xs text-[color:var(--color-muted)]">{content.footer.bottomLine}</p>
      </Container>
    </footer>
  );
}
